import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { handleGetPatientsData } from '../patient/saga'
import { handleGetPatientsAdmissionData } from '../patientAdmission/saga'
import {
  ADD_PATIENT_ALERT_CONFIGURATION,
  GET_PATIENT_ALERT_CONFIGURATION,
} from './actionTypes'
import {
  addPatientAlertConfigurationData,
  getPatientAlertConfigurationData,
} from './api'
import {
  addPatientAlertConfigurationSuccess,
  errorPatientAlertConfiguration,
  getPatientAlertConfiguration,
  successPatientAlertConfiguration,
} from './patientAlertConfigurationReducer'
import { AlertConfiguration, PatientAlertConfiguration } from './types'

type Action = {
  type: string
  payload: string
}

export function* handleGetAlertConfigurationData(
  actions: Action
): SagaIterator<void> {
  try {
    const response = yield call(
      getPatientAlertConfigurationData,
      actions.payload
    )
    const { data } = response
    let newData: PatientAlertConfiguration = {
      patientKey: actions.payload,
      alertConfiguration: data.result,
    }
    yield put(addPatientAlertConfigurationSuccess(newData))
  } catch (error: any) {
    yield put(errorPatientAlertConfiguration(error.response.data.message))
  }
}

type PostAction = {
  type: string
  payload: {
    patientKey: string
    alertConfiguration: AlertConfiguration
  }
}

export function* handleAddPatientAlertConfigurationData(
  actions: PostAction
): SagaIterator<void> {
  try {
    const response = yield call(
      addPatientAlertConfigurationData,
      actions.payload.patientKey,
      actions.payload.alertConfiguration
    )
    const { data } = response
    yield put(successPatientAlertConfiguration(data.message))
    yield put(getPatientAlertConfiguration(actions.payload.patientKey))
    yield call(handleGetPatientsData)
    yield call(handleGetPatientsAdmissionData)
  } catch (error: any) {
    yield put(errorPatientAlertConfiguration(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(
    GET_PATIENT_ALERT_CONFIGURATION,
    handleGetAlertConfigurationData
  )
  yield takeLatest(
    ADD_PATIENT_ALERT_CONFIGURATION,
    handleAddPatientAlertConfigurationData
  )
}

export const patientAlertConfigurationSaga = [fork(watcherSaga)]
